import { render, staticRenderFns } from "./VDynamicTable.vue?vue&type=template&id=6f339404&"
import script from "./VDynamicTable.vue?vue&type=script&lang=ts&"
export * from "./VDynamicTable.vue?vue&type=script&lang=ts&"
import style0 from "./VDynamicTable.vue?vue&type=style&index=0&id=6f339404&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports